// extracted by mini-css-extract-plugin
export var cancelButton = "_n0-5";
export var content = "_n0-3";
export var createButton = "_n0-6";
export var drawerContainer = "_n0-0";
export var footer = "_n0-2";
export var header = "_n0-1";
export var orderFormColumn = "_n0-4";